import React, { useMemo, useState } from "react";
import { FaFileAlt } from "react-icons/fa";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { useNavigateToGivenPath } from "views/pages/manage/edpOps/studentDetails/paymentSummary/service";
import { updateRequest } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

import CashLocationCard from "../../cash-management/components/CashLocationCard";
import FilterDrawer from "../../cash-management/components/CashLocationFilterDrawer";
import TablePagination from "../../cash-management/components/TablePagination";
import TipsSidebar from "../../cash-management/components/TipsSidebar";
import ModuleHeaderBar from "../../cash-management/components/TopHeaderBar";
import ALoader from "views/pages/manage/common/a-loader";

import { useFetchDropdown } from "../../cash-management/hooks/useDropdown";
import { downloadCashReport } from "../../cash-management/api";
import { useCashLocations } from "../../cash-management/hooks/useCashLocations";
import { getLocationWithDescription } from "modules/paymentManagement/utils";

import "../../cash-management/styles/cashManagement.scss";
import { chequeTips, dashBoardFilterBtnStyle } from "../utils";
import { isLiveBranch } from "../../utils";
import { useGetPermissions } from "layouts/customHook";
import { checkPermission } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";

const ChequeManagementDashboard = () => {
  const [isDropdownLoading, setIsDropdownLoading] = useState(false);
  const { dropdownValues, isDropdownApiLoading } =
    useFetchDropdown(setIsDropdownLoading);
  const liveBranches = dropdownValues.businessAreas.filter(isLiveBranch);

    const userPermissions = useGetPermissions('chequePaymentManagement')
    const isWritePermission = checkPermission(userPermissions, "C")||checkPermission(userPermissions, "U");

  const {
    rows: locations,
    loading,
    total,
    pageNo,
    totalPages,
    pageSize,
    nextButtonHandler,
    applyFilter,
    filters,
  } = useCashLocations(
    { pageNo: 0, pageSize: 10 },
    { enabled: isDropdownLoading },
    liveBranches,
    "CHEQUE"
  );

  const navigate = useNavigateToGivenPath();

  const locationWithDescription = getLocationWithDescription(
    locations,
    dropdownValues.businessAreas
  );
  const filterCount = useMemo(
    () =>
      Object.values(filters).filter(
        (item) => item.length > 0 || (!Array.isArray(item) && item !== "")
      )?.length,
    [filters]
  );

  const pagination = {
    total,
    page: pageNo,
    pageSize,
    totalPages,
  };

  const applyFilterHandler = (currentFilter) => {
    const updatedFilter = updateRequest(currentFilter);
    applyFilter(updatedFilter);
  };

  const onRemoveFilterHandler = () => {
    applyFilter({});
  };

  const goViewReceipts = (locationId, cashierOffice) =>
    navigate(
      `/admin/cheque-management/receipts/${locationId}/${cashierOffice}`
    );

  const goViewDeposit = (locationId, cashierOffice) =>
    navigate(
      `/admin/cheque-management/deposits/${locationId}/${cashierOffice}`
    );

  const goViewDeposited = (locationId, cashierOffice) =>
    navigate(
      `/admin/cheque-management/depositedSlips/${locationId}/${cashierOffice}`
    );

   const goBackToDashboard = () => {
      navigate(`/admin/paymentManagement`);
    }

  const onPageSizeChangeHandler = (pageSize) => {
    nextButtonHandler(0, pageSize);
  };
  const onPageChangeHandler = (page) => {
    nextButtonHandler(page, pagination.pageSize);
  };

  if (!isDropdownApiLoading && liveBranches.length === 0) {
    return (
      <div className="display-2 text-center mt-4">
        This feature is not live yet on your branch
      </div>
    );
  }

  return (
    <div className="remove-container-top-space">
      <ModuleHeaderBar
        onBackClick={goBackToDashboard}
        title="Cheque management"
      >
        <div>
          <FilterDrawer
            appliedForm={filters}
            onRemoveFilterHandler={onRemoveFilterHandler}
            applyFilterHandler={applyFilterHandler}
            dropdownValues={dropdownValues}
            filterCount={filterCount}
            liveBranches={liveBranches}
            isCheque={true}
          />
          <AButton
            size="xs"
            variant="general"
            updatedStyle={dashBoardFilterBtnStyle}
            disabled={!filterCount}
            onClick={() => downloadCashReport(filters, "CHEQUE")}
          >
            <div className="cm-card-btn">
              <FaFileAlt />
              Cheque report
            </div>
          </AButton>
        </div>
      </ModuleHeaderBar>
      <div className="cm-container">
        {(loading || isDropdownApiLoading) && (
          <ALoader position="fixed"></ALoader>
        )}
        {!loading && !isDropdownApiLoading && locations.length === 0 && (
          <div className="text-center">No locations found</div>
        )}

        <div className="cm-grid">
          {/* Left side – list of cards */}
          <div className="cm-cards">
            {locationWithDescription.map((loc, index) => (
              <CashLocationCard
                key={` ${index}-${loc?.businessAreaValue}-${loc?.cashierOffice}`}
                location={loc}
                onViewReceipts={goViewDeposit}
                onSendDeposit={goViewReceipts}
                onViewDeposit={goViewDeposited}
                onViewReport={() => {}}
                title="Cheque in hand"
                isCheque={true}
                isWritePermission={isWritePermission}
              />
            ))}

            {/* Pagination */}
            {totalPages > 0 && (
              <TablePagination
                loading={loading}
                pagination={pagination}
                onPageChange={onPageChangeHandler}
                onPageSizeChange={onPageSizeChangeHandler}
              />
            )}
          </div>

          {/* Right side – Tips panel */}
          <TipsSidebar tips={chequeTips} />
        </div>
      </div>
    </div>
  );
};

export default ChequeManagementDashboard;
